import React from 'react'
import { formatMessengerTime } from '../../Utils/formatMessengerTime/formatMessengerTime';
import HTMLReactParser from "html-react-parser";
export const SingleItem = ({ data, handleReply, handleDelete, HandleShowImage }) => {
    // console.log(data)
    return (
        <>


            {data?.userId && !data?.adminId && (
                <div className="chat-messages">
                    <div className="messages-left">
                        <div className="user-avater">
                            <img src={
                                data?.userId?.picture
                                    ? `${process.env.REACT_APP_Authorized_API_URL}/${data?.userId?.picture}`
                                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                            }
                                onError={(e) => (e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s")} alt="" />
                        </div>

                        <div className="message-area">
                            <div className="user-name">
                                <p>{data?.userId?.fname} {data?.userId?.lname}</p>
                            </div>
                            <div className="message">
                                <p> {data?.text}</p>
                                <div className="image-gallery">
                                    <div className={`gallery gallery-${data?.images.length}`}>

                                        {data?.images?.length > 0 && (
                                            <div className="image-gallery">
                                                <div className={`gallery gallery-${data?.images.length}`}>
                                                    {data?.images.map((data, index) => {
                                                        if (!data) return null;

                                                        return (
                                                            <div className="image-box" key={index}>
                                                                <img
                                                                    src={data}
                                                                    alt={`image-${index + 1}`}
                                                                    onClick={() => HandleShowImage(data)}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <p className='message-time'>{formatMessengerTime(data.createdAt)}</p>
                            </div>

                        </div>


                    </div>
                </div>
            )}


            {/* admin message  */}

            {data?.userId && data?.adminId && (
                <div className="chat-messages">
                    <div className="messages-right">

                        <div className="message-area">

                            <div className="message">
                                <div className="user-name">
                                    <p>{data?.adminId?.name}</p>
                                </div>
                                {/* <p>{data?.text}</p> */}

                                 {data?.text ? HTMLReactParser(data?.text) : ""}


                                {data?.images?.length > 0 && (
                                    <div className="image-gallery">
                                        <div className={`gallery gallery-${data?.images.length}`}>
                                            {data?.images.map((data, index) => {
                                                if (!data) return null;

                                                return (
                                                    <div className="image-box" key={index}>
                                                        <img
                                                            src={data}
                                                            alt={`image-${index + 1}`}
                                                            onClick={() => HandleShowImage(data)}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                <p className='message-time'>{formatMessengerTime(data.createdAt)}</p>
                            </div>

                        </div>
                        <div className="user-avater">
                            <img src={
                                data?.adminId?.picture
                                    ? `${process.env.REACT_APP_Authorized_API_URL}/${data?.adminId?.picture}`
                                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                            }
                                onError={(e) => (e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s")} alt="" />
                        </div>
                    </div>
                </div>
            )}


            {/* admin message end */}

        </>
    )
}
